import { render, staticRenderFns } from "./batch-summary-footer.vue?vue&type=template&id=bd867e5c&scoped=true&"
import script from "./batch-summary-footer.vue?vue&type=script&lang=js&"
export * from "./batch-summary-footer.vue?vue&type=script&lang=js&"
import style0 from "./batch-summary-footer.vue?vue&type=style&index=0&id=bd867e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd867e5c",
  null
  
)

export default component.exports